export const texts = {
  title: {
    de: 'Berufsausbildung',
    en: 'Education'
  },
  noInformation: {
    de: 'Es liegen keine Angaben vor',
    en: 'No information available'
  },
  to: {
    de: 'bis',
    en: 'to'
  },
  toPresent: {
    de: 'bis heute',
    en: 'to present'
  },
  aboutOneMonth: {
    de: 'ca. ein Monat',
    en: 'approx. one month'
  },
  unknownDuration: {
    de: 'unbekannte Dauer',
    en: 'unknown duration'
  },
  cvFileName: {
    de: 'Lebenslauf.pdf',
    en: 'CV.pdf'
  }
};
